import * as React from 'react';
import { SVGProps } from 'react';

const IconLentaFilledSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v7s0 2 2 2v2H3a2 2 0 0 1-2-2V4Zm3 1v4h2V7h2V5H4Zm3 7v-2h2V8h2v4H7Z"
    />
  </svg>
);
export default IconLentaFilledSizeS;
